import React from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, money } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const cancelled = location.pathname.includes("cancel");
  const sessionId = params.get("session_id");

  const { data, isLoading } = useQuery({
    queryKey: ["pay-status", sessionId],
    queryFn: () => api.get(`/payments/status/${sessionId}`).then((r) => r.data),
    enabled: !!sessionId && !cancelled,
    refetchInterval: (q) => (q.state.data?.payment_status === "paid" ? false : 2000),
  });

  const paid = data?.payment_status === "paid";

  return (
    <div className="max-w-md mx-auto py-16">
      <Card className="p-8 text-center border-border shadow-[0_4px_20px_rgba(42,42,42,0.04)]">
        {cancelled ? (
          <>
            <XCircle className="w-14 h-14 text-destructive mx-auto mb-4" />
            <h1 className="text-2xl font-semibold text-teak mb-2">{t("fin.payOnline")}</h1>
            <p className="text-muted-foreground mb-6">{t("res.cancelled")}</p>
          </>
        ) : isLoading || !paid ? (
          <>
            <Loader2 className="w-14 h-14 text-teak mx-auto mb-4 animate-spin" />
            <h1 className="text-2xl font-semibold text-teak mb-2">{t("common.loading")}</h1>
            <p className="text-muted-foreground mb-6">Stripe · THB</p>
          </>
        ) : (
          <>
            <CheckCircle2 className="w-14 h-14 text-[#2D6A4F] mx-auto mb-4" />
            <h1 className="text-2xl font-semibold text-teak mb-2">{t("fin.paid")}</h1>
            <p className="text-muted-foreground mb-6" data-testid="payment-success">{t("fin.payOnline")} · Stripe</p>
          </>
        )}
        <Button onClick={() => navigate("/admin/finances")} className="bg-teak hover:bg-teak-hover text-white" data-testid="back-finances-btn">
          {t("nav.finances")}
        </Button>
      </Card>
    </div>
  );
}
